import {CommonModule} from "@angular/common";
import {Component} from "@angular/core";
import {MatDialogModule} from "@angular/material/dialog";
import {ButtonComponent} from "daisy-design-system-front";
import {ButtonModule} from "primeng/button";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: "app-dialog-confirm-stations-display",
  templateUrl: "./dialog-confirm-stations-display.component.html",
  styleUrls: ["./dialog-confirm-stations-display.component.scss"],
  standalone: true,
  imports: [CommonModule, MatDialogModule, ButtonModule, ButtonComponent, TranslateModule],
})
export class DialogConfirmStationsDisplayComponent {
  public excludeOrInclude: 'exclude' | 'include';

  constructor(
    private readonly ref: DynamicDialogRef,
    public config: DynamicDialogConfig<{ checked: boolean | undefined }>
  ) {
    this.excludeOrInclude = this.config.data?.checked ? 'include' : 'exclude';
  }

  closeMe(accept = false) {
    this.ref.close({ accept });
  }
}
